<template>
    <v-container>
        <v-card class="elevation-1">
            <v-card-title>
                <h3>Roles</h3>
                <v-spacer></v-spacer>
                <v-dialog v-model="dialog" persistent max-width="600px">
                    <v-card>
                        <v-card-title>
                            <span
                                class="text-h5"
                                v-if="currentAction === 'create'"
                                >Create Role</span
                            >
                            <span
                                class="text-h5"
                                v-if="currentAction === 'update'"
                                >Update Role</span
                            >
                        </v-card-title>
                        <v-card-text>
                            <v-container>
                                <v-row no-gutters>
                                    <v-col cols="12">
                                        <v-text-field
                                            label="Role Name*"
                                            v-model="role.name"
                                            required
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                color="indigo darken-1"
                                text
                                @click="dialog = false"
                            >
                                Cancel
                            </v-btn>
                            <v-btn
                                v-if="currentAction === 'create'"
                                color="indigo darken-1"
                                text
                                @click="createRole"
                            >
                                Create
                            </v-btn>
                            <v-btn
                                v-if="currentAction === 'update'"
                                color="indigo darken-1"
                                text
                                @click="updateRole"
                            >
                                Update
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <v-btn color="indigo darken-1" dark @click="openDailog"
                    >Create Role</v-btn
                >
            </v-card-title>
            <v-data-table
                :headers="headers"
                :items="roles"
                :items-per-page="10"
                class="elevation-2"
            >
                <template v-slot:[`item.actions`]="{ item }">
                    <v-icon small class="mr-2" @click="editRole(item)">
                        mdi-pencil
                    </v-icon>
                    <v-icon small @click="deleteRole(item.id)">
                        mdi-delete
                    </v-icon>
                </template>
            </v-data-table>
        </v-card>
        <v-snackbar v-model="snackbar">
            {{ message }}
            <template v-slot:action="{ attrs }">
                <v-btn
                    color="white"
                    text
                    v-bind="attrs"
                    @click="snackbar = false"
                    >Close</v-btn
                >
            </template>
        </v-snackbar>
    </v-container>
</template>
<script>
import { mapGetters } from "vuex";
export default {
    name: "RolesList",
    data() {
        return {
            dialog: false,
            snackbar: false,
            message: "",
            role: [],
            currentAction: "",
            headers: [
                { text: "Role", value: "name", width: "80%" },
                { text: "Actions", value: "actions", sortable: false },
            ],
        };
    },
    components: {},
    props: {
        msg: String,
    },
    computed: {
        ...mapGetters({
            roles: "getRoles"
        })
    },
    methods: {
        openDailog() {
			this.role = [];
            this.currentAction = "create";
            this.dialog = true;
        },
        createRole() {
            this.$store.commit("incrementRoleId");
            this.$store.commit("createRole", Object.assign({}, this.role));
            this.dialog = false;
            this.message = "Role created successfully";
            this.snackbar = true;
        },
        editRole(role) {
            this.currentAction = "update";
            this.dialog = true;
            this.currentRoleId = role.id;
            this.role = Object.assign({}, role);
            this.message = "Role updated successfully";
            this.snackbar = true;
        },
        updateRole() {
            this.dialog = false;
            this.$store.commit("updateRole", this.role);
        },
        deleteRole(roleId) {
            this.$store.commit("deleteRole", roleId);
            this.message = "Role deleted successfully";
            this.snackbar = true;
        },
    },
};
</script>

